import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { WithId } from '@framework/form';
import React from 'react';
import styled from 'styled-components';
import { IWidgetOption } from '../../../../Widget';
import { WidgetOptionView } from './WidgetOptionView';

const SortableDiv = styled.div`
  padding: 6px 0;

  &:first-child {
    padding-top: 0;
    border-color: transparent;
  }
  & + & {
    border-top: 1px solid ${props => props.theme.colorBorderSecondary}; // #d9d9d9;
    &:last-child {
      padding-bottom: 12px;
    }
  }
`;

export interface ISortableWidgetOptionItemProps {
  item: IWidgetOption;
  uid: string;
  type: 'option' | 'divider';
  active: WithId<IWidgetOption> | null;
  onEdit: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

export function SortableWidgetOptionItem(
  props: ISortableWidgetOptionItemProps,
) {
  const { uid, active, ...otherProps } = props;
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: uid });
  return (
    <SortableDiv
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        // Lo nascondo se è quello selezionato
        visibility: active?.__uid === uid ? 'hidden' : 'visible',
      }}
      {...attributes}
    >
      <WidgetOptionView {...otherProps} listeners={listeners} />
    </SortableDiv>
  );
}
